class Controller {
  constructor($element) {
    "ngInject";

    this.$element = $element;

    this.uniqueFormId = Math.random().toString(36).substr(2);
  }

  $onInit() {
    this.addStep();
  }

  $onDestroy() {
    this.removeStep();
  }

  addStep() {
    this.$stepsCtrl.addToSteps(this);
  }

  removeStep() {
    this.$stepsCtrl.removeFromSteps(this);
  }

  toggleActive(isActive, before) {
    if (isActive) {
      this.$element.addClass("active");
      this.$element.removeClass("step-left step-right");
    } else {
      this.$element.removeClass("active");

      if (before) {
        this.$element.addClass("step-left");
      } else {
        this.$element.addClass("step-right");
      }
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/formStep/formStep.controller.js